import React from 'react';
import { RMAXLogger } from '../../services/LoggerService/RMAXLogger';
import {
  generateErrorId,
  generateErrorReportTitle,
  categorizeError,
  formatErrorReport
} from '../utils/errorUtils';

class BaseErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      errorId: null,
      errorCategory: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const errorId = generateErrorId(this.props.errorIdPrefix || 'ERR_');
    const errorCategory = categorizeError(error);
    const reportType = this.props.reportType || 'Error Report';

    if (typeof window !== 'undefined' && typeof window.reportError === 'function') {
      // React Error Boundaries prevent errors from bubbling to the window,
      // so Chrome DevTools won’t show them as native "Uncaught" errors.
      // Re-report here to restore native visibility while still rendering the fallback UI.
      window.reportError(error);
    }
    
    // Log to RMAXLogger for Datadog tracking
    const errorReport = formatErrorReport({ error, errorInfo, errorId, reportType });
    const errorTitle = generateErrorReportTitle(errorId, reportType);
    RMAXLogger.error(`${errorTitle}:`, errorReport);

    this.setState({
      error,
      errorInfo,
      errorId,
      errorCategory
    });
  }

  render() {
    if (this.state.hasError) {
      const { error, errorInfo, errorId, errorCategory } = this.state;
      const { errorFallbackComponent: ErrorFallbackComponent, ...otherProps } = this.props;

      return (
        <ErrorFallbackComponent
          error={error}
          errorInfo={errorInfo}
          errorId={errorId}
          errorCategory={errorCategory}
          {...otherProps}
        />
      );
    }

    return this.props.children;
  }
}

export default BaseErrorBoundary;
